import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3l-2 6l2 12h6l2 -12l-2 -6l-6 0","key":"svg-0"}],["path",{"d":"M10 7v5","key":"svg-1"}],["path",{"d":"M8 9h4","key":"svg-2"}],["path",{"d":"M13 21h4l2 -12l-2 -6h-4","key":"svg-3"}]]

const IconCoffin = createReactComponent('outline', 'coffin', 'Coffin', __iconNode);

export default IconCoffin;